import { api } from './api';
import type { InlogAanvraag, InlogRespons } from '@types';

// ============================================
// Auth API Functions
// ============================================

/**
 * Meld een gebruiker aan
 * @param credentials - Inloggegevens (email en wachtwoord)
 * @returns InlogRespons met gebruikergegevens
 */
export const login = async (credentials: InlogAanvraag): Promise<InlogRespons> => {
  const response = await api.post<InlogRespons>('/gebruikers/login', credentials);
  return response.data;
};

/**
 * Meld een gebruiker af
 */
export const logout = async (): Promise<void> => {
  await api.post('/gebruikers/logout');
};
